<template>
    <aside id="cookieInfo" class="hidden-print" v-if="show">
        <div class="container">
            <div class="col-md-10">
                <p>
                    {{ $t("cookie.text") }}
                    <button type="button" class="btn btn-link" v-on:click="morInfo()">{{ $t("cookie.label_info")}}&nbsp;&raquo;</button>
                </p>

            </div>
            <div class="col-md-2">
                <button type="button" v-on:click="accept()" class="btn btn-default btn-block">{{ $t("cookie.label_accept") }}</button>
            </div>
        </div>
    </aside>
</template>
<style>

    #cookieInfo{
        position: fixed;
        bottom:0;
        left:0;
        right:0;
        z-index: 10000;
        background: #000;
        background: rgba(0,0,0,.8);
        padding:20px 0 ;
    }

    #cookieInfo p {
        color:#fff;
        line-height: 1.1;
    }

    #cookieInfo p button{
        padding: 0;
    }

</style>
<script>
    export default {

        name : 'cookie-panel',

        data() {
            return {
                show : false,
            }
        },

        props: {
            name : {
                type: String,
                default: 'accept'
            },
            path : {
                type: String,
                default: '/'
            },
            expires : {
                type: Number,
                default: 365
            },

            url_terms : {
                type: String,
                default: '/terms'
            },
        },

        mounted() {

            if(!$.cookie(this.name)){
                this.show = true;
                $.cookie(this.name, 'true', {
                    expires:    this.expires,
                    path:       this.path,
                });
            }
        },

        methods :{

            accept:function(data, e){

                this.show = false;
                this.$emit('on-accept', data, e);
            },

            morInfo:function(data, e){

                window.open(this.url_terms);
                this.$emit('on-info', data, e);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/cookiePanel.vue